<script lang="ts">
  import '@splidejs/splide/dist/css/themes/splide-default.min.css';
  import { afterUpdate, onMount } from 'svelte';
  import { getAppConfig } from '../../../common/config/app-config';
  import { APP_CONSTANTS } from '../../../common/config/app-constants';
  import {
    displayBanners,
    getMiraklSponsoredProductsPDPAsync,
    miraklSponsoredProducts,
  } from '../../../common/store/mirakl-ads-store';
  import { unbxdConfigdata } from '../../../common/store/unbxd-config-store';
  import { isMobileUIExperience, isMobileWidth } from '../../../common/util';
  import BasketLevelPromotion from '../../common/components/BasketLevelPromotion.svelte';
  import ExtraSnackBar from '../../common/components/ExtraSnackBar.svelte';
  import IntersectionObserver from '../../common/components/IntersectionObserver.svelte';
  import MegaSaleBanner from '../../common/components/MegaSaleBanner.svelte';
  import ProductConditionCard from '../../common/components/ProductConditionCard.svelte';
  import ProductTilePriceNewGroup from '../../common/components/productTile/components/ProductTilePriceNewGroup.svelte';
  import TagContainer from '../../common/components/tag/TagContainer.svelte';
  import ProductCarouselComponent from '../../common/lazy-components/ProductCarouselComponent.svelte';
  import AppFooterPage from '../../footer/AppFooterPage.svelte';
  import MPOtherSellersSection from '../components/MPComponents/MPOtherSellersSection.svelte';
  import MpSellerInfoSection from '../components/MPComponents/MPSellerInfoSection.svelte';
  import OtherSellerDetailsModal from '../components/MPComponents/OtherSellerDetailsModal.svelte';
  import {
    addGiftToCartPayload,
    addProductToCart,
    filterOutPromotions,
    getTestFreakData,
    manualBundlePayload,
    onClickWishlist,
    redirectToLocationHash,
    sendBundleCartData,
  } from '../services/pdp-data-services';
  import {
    addToCartData,
    openPdpJoodBenefitInfoPopup,
    openServicesInfoPopup,
    pdpBundlePromotionData,
    pdpHighlightPopupData,
    pdpJoodBenefitInfo,
    pdpManualBundleData,
    pdpSellerInfoData,
    pdpSpecsAndStickyBarData,
    pdpTitleData,
    productDetailMainData,
    productImagesData,
    prodUnavailableData,
    testFreakData,
  } from '../store/pdp_store';
  import {
    addToCartContent,
    currentSelectedStoreData,
    giftCardAmount,
    giftvalidemail,
    openAddToCartDrawer,
    pdpDeliveryOptionCardData,
    pdpGiftCardPriceData,
    pdpInstalmentCardData,
    pdpOfferCardData,
    pdpProductExtraLinksData,
    pdpProductPrice,
    pdpServiceCardData,
    productDetails,
    selectedGiftGroup,
    selectedGifts,
    servicesInfo,
  } from './../store/pdp_store.js';
  import AddToCartContainer from './AddToCartContainer.svelte';
  import AddToCartDialog from './AddToCartDialog.svelte';
  import HighLightsAndSpecifications from './HighLightsAndSpecifications.svelte';
  import HighlightDetailsPopup from './HighlightDetailsPopup.svelte';
  import PdpDeliveryOptionsCard from './PDPDeliveryOptionsCard.svelte';
  import ManualBundle from './PDPFrequentlyBought/ManualBundle.svelte';
  import PdpInstallmentsCard from './PDPInstallmentsCard.svelte';
  import PdpJoodBenefitModal from './PDPJoodBenefitModal.svelte';
  import PdpOffersCard from './PDPOffersCard.svelte';
  import PdpServicesCard from './PDPServicesCard.svelte';
  import PdpServicesCardv2 from './PDPServicesCardv2.svelte';
  import PDPServicesInfoModal from './PDPServicesInfoModal.svelte';
  import PdpSmallBoxSection from './PDPSmallBoxSection.svelte';
  import PDPSpecialOffersLink from './PDPSpecialOffersLink.svelte';
  import PdpBundlePromotion from './PdpBundlePromotion/PdpBundlePromotion.svelte';
  import PdpDealTimer from './PdpDealTimer.svelte';
  import PdpDivider from './PdpDivider.svelte';
  import PdpGiftOption from './PdpGiftOption.svelte';
  import PdpMainTile from './PdpMainTile.svelte';
  import PdpPriceAlert from './PdpPriceAlert.svelte';
  import PdpRsaView from './PdpRsaView.svelte';
  import ProductDetailsSameSku from './ProductDetailsSameSKU/ProductDetailsSameSKU.svelte';
  import ProductExtraLinks from './ProductExtraLinks.svelte';
  import ProductLiveVideo from './ProductLiveVideo.svelte';
  import ProductShopMoreSection from './ProductShopMoreSection.svelte';
  import ProductSpecialOffers from './ProductSpecialOffers.svelte';
  import ProductDetailsSpecs from './ProductStory/ProductDetailsSpecs.svelte';
  import ProductTitle from './ProductTitle.svelte';
  import ProductUnAvailable from './ProductUnAvailable.svelte';
  import SoldAndShipped from './SoldAndShipped.svelte';
  import StickyBar from './StickyBar.svelte';
  import WriteReview from './WriteReview/WriteReview.svelte';
  import ProductImages from './productImages.svelte';
  import ProductReviewHead from './productReviewHead.svelte';

  $productDetails = window['ACC'].config.productDetails;
  $unbxdConfigdata = window['ACC'].config.unbxdSearchConfig;
  const {
    megaSaleComponentId,
    svelteModuleFooterEnabled,
    priceAlertEnabled,
    miraklads: { miraklAdsEnabledPdp },
  } = getAppConfig();
  const isResponsive = isMobileWidth();

  $: cfsSelectedStoreData = $currentSelectedStoreData;

  $: cfsInStock =
    cfsSelectedStoreData?.stockLevelStatus?.code === 'inStock' ||
    cfsSelectedStoreData?.stockLevelStatus?.code === 'lowStock';
  $: isStockAvailableForCurrentStore =
    ($productDetailMainData?.stockStatus && ($productDetailMainData?.deliveryInStock || cfsInStock)) ||
    ($productDetailMainData?.isDigitalGiftCard &&
      (!$giftvalidemail ||
        !$giftCardAmount ||
        $giftCardAmount < $productDetailMainData?.minGiftCardAmount ||
        $giftCardAmount > $productDetailMainData?.maxGiftCardAmount));
  $: isProductAvailability =
    $productDetailMainData?.stock.stockLevelStatus.code != 'outOfStock' && !$productDetailMainData?.isComingSoon;

  $: showProductConditionCard =
    ($pdpSellerInfoData.marketPlaceOfferData?.conditionCode === APP_CONSTANTS.PRODUCT_CONDITIONS.OPEN_BOX ||
      $pdpSellerInfoData.marketPlaceOfferData?.conditionCode === APP_CONSTANTS.PRODUCT_CONDITIONS.RENEWED) &&
    ($pdpSellerInfoData.marketPlaceOfferData?.conditionLabels?.length ?? 0) > 0;

  $: isSellerDataAvailable = $pdpSellerInfoData.marketPlaceShopDetails !== null;
  $: isOtherSellerDataAvailable = $pdpSellerInfoData.otherSellersCount !== 0;

  let hasBasketPromotions = $productDetailMainData?.basketPromotions?.length;
  let hasBundlePromotions =
    $productDetailMainData?.specialOfferDataList && $productDetailMainData?.specialOfferDataList.length > 0;
  let potentialPromotionsFiltered = filterOutPromotions($productDetails?.potentialPromotions);
  let hasSpecialOffersSection = hasBasketPromotions || hasBundlePromotions || potentialPromotionsFiltered;

  onMount(async () => {
    getTestFreakData();
    redirectToLocationHash();
    window.ACC.miraklads.trackProductDetailPage(window.ACC.config.productDetails.code);
    if (miraklAdsEnabledPdp) {
      getMiraklSponsoredProductsPDPAsync($productDetails.code);
      window.ACC.miraklads.tagWatchViewability();
    }
  });

  let showOnPx = 0;
  let navHeight = 0;
  let headerHeight = 0;
  let writeReviewOpen = false;
  let desktopAddToCartContainer: HTMLDivElement;
  let desktopLeftContent: HTMLDivElement;
  $: showPriceForComingSoon =
    !$productDetailMainData?.isComingSoon ||
    ($productDetailMainData?.isComingSoon && !$productDetailMainData?.hidePriceForComingSoon);

  function updateStickyOffsets() {
    navHeight = document.querySelector('.header-desktop')?.clientHeight;
    navHeight = navHeight ? navHeight : 80;
    headerHeight = desktopLeftContent?.clientHeight || document.querySelector('.left-content')?.clientHeight;
    headerHeight = headerHeight ? headerHeight : 1470;
    showOnPx = headerHeight + navHeight;
    document.documentElement.style.setProperty('--stickyBarTop', `${navHeight}px`);
    document.documentElement.style.setProperty('--pdpDesktopStickyTop', `${navHeight + 16}px`);
  }

  function updateStickyHeaderState() {
    if (!desktopAddToCartContainer) {
      hideTopAddToCart = true;
      document.querySelector('html')?.classList.remove('pdp-sticky-added');
      return;
    }

    const { bottom } = desktopAddToCartContainer.getBoundingClientRect();
    hideTopAddToCart = bottom > navHeight;
    document.querySelector('html')?.classList.toggle('pdp-sticky-added', !hideTopAddToCart);
  }

  onMount(async () => {
    updateStickyOffsets();
    updateStickyHeaderState();

    // MAVD:2671
    currentSelectedStoreData.set({
      stockLevelStatus: {
        code: $productDetailMainData.cfsPosPickUpInStoreData?.defaultPos?.stockData?.stockLevelStatus?.code,
        type: $productDetailMainData.cfsPosPickUpInStoreData?.defaultPos?.stockData?.stockLevelStatus?.type,
      },
      stockLevel: $productDetailMainData.cfsPosPickUpInStoreData?.defaultPos?.stockData?.stockLevel,
      stockThreshold: $productDetailMainData.cfsPosPickUpInStoreData?.defaultPos?.stockData?.stockThreshold,
    });
    //code cleanup for event digital Product

    if (!isStockAvailableForCurrentStore) {
      // hide emptyContainer when product is out of stock
      document
        .getElementsByClassName('bottom-content')[0]
        .getElementsByClassName('emptyContainer')[0]
        .setAttribute('style', 'display:none');
    }
  });
  afterUpdate(() => {
    updateStickyOffsets();
    updateStickyHeaderState();
  });
  let hideTopAddToCart = true;

  function scrollContainer() {
    return document.documentElement || document.body;
  }

  function handleOnScroll() {
    if (!scrollContainer()) {
      return;
    }

    if (desktopAddToCartContainer) {
      updateStickyHeaderState();
      return;
    }

    if (scrollContainer().scrollTop > showOnPx) {
      hideTopAddToCart = false;
      document.querySelector('html')?.classList.add('pdp-sticky-added');
    } else {
      hideTopAddToCart = true;
      document.querySelector('html')?.classList.remove('pdp-sticky-added');
    }
  }

  function onAddToCart(): void {
    addProductToCart(
      $productDetailMainData?.isTransactional,
      $productDetailMainData?.hasFreeGift,
      $productDetailMainData?.freeGiftDataList,
      $selectedGifts,
      $selectedGiftGroup,
      $productDetailMainData?.isRSAItem
    );
  }

  let isWhishList = $productDetails.inWhishList === true ? true : false;
  $: wishlistedItemId = $productDetails?.wishlistEntryPk;

  function handleWishlistChange(data) {
    onClickWishlist(data, isWhishList, wishlistedItemId);
  }

  function addBundleToCart(index) {
    sendBundleCartData(index);
  }

  $: updateBreadcrumbOnNameChange($productDetailMainData.name);

  function updateBreadcrumbOnNameChange(newName) {
    if (newName?.length > 0) {
      const bcDom = document.querySelector('.c_breadcrumb > ul > li.active');
      if (bcDom) {
        bcDom.innerHTML = newName;
      }
    }
  }
</script>

<svelte:window on:scroll={handleOnScroll} />

{#if $productDetailMainData?.isDigitalGiftCard || (!$productDetailMainData?.isComingSoon && $productDetailMainData?.stock.stockLevelStatus.code != 'outOfStock')}
  {#if !hideTopAddToCart}
    <div class="sticky_header_bar hide-on-mobile">
      <StickyBar
        data={$pdpSpecsAndStickyBarData}
        on:addToCart={() => onAddToCart()}
        on:changeWishList={data => {
          handleWishlistChange(data);
        }}
      />
    </div>
  {/if}
{/if}

<PdpDealTimer />

<div class="pdp-container {$productDetailMainData?.isMegaSaleProductFlag ? 'c_megasale' : ''}">
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class="title-container">
    <div class="hide-on-mobile"><TagContainer productTags={$productDetailMainData.productTags} /></div>
    <ProductTitle data={$pdpTitleData} />
    <div class="hide-on-desktop"><TagContainer productTags={$productDetailMainData.productTags} /></div>
    <SoldAndShipped data={$pdpSellerInfoData} />
    <div class="hide-on-mobile">
      <ProductReviewHead ProductRatingData={$testFreakData} />
    </div>
  </div>
  <div class="left-content" bind:this={desktopLeftContent}>
    <div class={$productDetailMainData?.isDigitalGiftCard ? 'light-container-giftCard' : 'light-container'}>
      <ProductImages data={$productImagesData} ProductRatingData={$testFreakData} />
      {#if !$productDetailMainData?.isDigitalGiftCard}
        <PdpSmallBoxSection
          data={$pdpSpecsAndStickyBarData}
          extraProductGalleryTiles={$productDetailMainData?.extraProductGalleryTiles}
          showekySyndication={true}
        />
      {/if}
      <div class="hide-on-mobile">
        <PdpMainTile keyHighlights={$productDetailMainData.keyHighlights} />
      </div>
    </div>
    <!-- <PdpDivider /> -->
    {#if !isResponsive}
      <HighLightsAndSpecifications
        data={$pdpSpecsAndStickyBarData}
        on:openWriteReview={() => (writeReviewOpen = true)}
      />
    {/if}
  </div>
  {#if !$productDetailMainData?.isDigitalGiftCard && !$productDetailMainData?.isComingSoon && $productDetailMainData?.stock.stockLevelStatus.code != 'outOfStock' && priceAlertEnabled}
    <div class="content d-flex justify-content-center extra_btn_wrapper hide-on-desktop">
      {#if $productDetailMainData?.productStatus !== 'PRE_ORDER'}
        <PdpPriceAlert productCode={$productDetailMainData?.code} />
      {/if}
    </div>
  {/if}
  <div class="right-content">
    <!-- New UI Start -->
    {#if showPriceForComingSoon}
      <div class="c_pdppricecontainer">
        <ProductTilePriceNewGroup
          isMegasaleProduct={$productDetailMainData?.isMegaSaleThemedProduct}
          product={$pdpProductPrice}
          pdpGiftCardPriceData={$pdpGiftCardPriceData}
          variant="pdp"
        />
      </div>
    {/if}

    {#if showProductConditionCard}
      <ProductConditionCard offer={$pdpSellerInfoData.marketPlaceOfferData} />
    {/if}

    {#if $productDetailMainData.productVariantGroups && $productDetailMainData.productVariantGroups.length > 0}
      <ProductDetailsSameSku
        productVariantGroups={$productDetailMainData.productVariantGroups}
        code={$productDetailMainData.code}
      />
    {/if}
    <OtherSellerDetailsModal />

    {#if isSellerDataAvailable}
      <MpSellerInfoSection data={$pdpSellerInfoData} />
    {/if}
    {#if isOtherSellerDataAvailable}
      <MPOtherSellersSection />
    {/if}

    {#if $productDetailMainData?.isMegaSaleProductFlag && $productDetailMainData?.isMegaSaleThemedProduct?.length && megaSaleComponentId}
      <MegaSaleBanner bannerClass={$productDetailMainData?.isMegaSaleProductFlag ? 'megasale-product' : ''} />
    {/if}

    {#if showPriceForComingSoon}
      <PdpInstallmentsCard data={$pdpInstalmentCardData} />
    {/if}

    <PdpOffersCard data={$pdpOfferCardData} />

    {#if Array.isArray($productDetailMainData?.freeGiftDataList) && $productDetailMainData.freeGiftDataList.length > 0}
      <PdpGiftOption
        freeGiftDataList={$productDetailMainData?.freeGiftDataList}
        on:giftSelectionForCart={addGiftToCartPayload}
      />
    {/if}
    {#if hasSpecialOffersSection}
      <PDPSpecialOffersLink />
    {/if}

    {#if $productDetailMainData?.isRSAItem}
      <PdpRsaView brands={$productDetailMainData?.brands} />
    {/if}
    {#if ($productDetailMainData?.isComingSoon && $productDetailMainData?.isDigitalGiftCard != true) || ($productDetailMainData?.stock.stockLevelStatus.code == 'outOfStock' && $productDetailMainData?.isDigitalGiftCard != true)}
      <ProductUnAvailable
        data={$prodUnavailableData}
        on:changeWishList={data => {
          handleWishlistChange(data);
        }}
      />
    {:else if $productDetailMainData?.isAddToCartEnabled}
      <div class="hide-on-mobile" bind:this={desktopAddToCartContainer}>
        <AddToCartContainer
          data={$addToCartData}
          on:addToCart={() => onAddToCart()}
          on:changeWishList={data => {
            handleWishlistChange(data);
          }}
        />
      </div>
    {/if}
    <div class="hide-on-mobile">
      <ProductExtraLinks data={$pdpProductExtraLinksData} />
    </div>

    <!-- New design card for services in PDP -->
    <PdpServicesCardv2 data={$pdpServiceCardData} eligibleVasEntries={$pdpServiceCardData.eligibleVasEntries} />

    <PdpServicesCard serviceType="appleCare" />
    {#if $productDetailMainData?.stock.stockLevelStatus.code != 'outOfStock'}
      <PdpDeliveryOptionsCard data={$pdpDeliveryOptionCardData} pdpGiftCardPriceData={$pdpGiftCardPriceData} />
    {/if}
    {#if $servicesInfo}
      <PDPServicesInfoModal open={$openServicesInfoPopup} exploreContentList={$servicesInfo.exploreContentList} />
    {/if}
    {#if $pdpJoodBenefitInfo}
      <PdpJoodBenefitModal open={$openPdpJoodBenefitInfoPopup} primeBenefits={$pdpJoodBenefitInfo} />
    {/if}
    {#if !isResponsive && isProductAvailability}
      <IntersectionObserver>
        {#if $productDetailMainData?.manualBundleProducts && $productDetailMainData?.manualBundleProducts.length > 0}
          <ManualBundle manualBundleData={$pdpManualBundleData} on:manualBundleToCart={manualBundlePayload} />
        {/if}

        <!-- WARN: If this component does more than that, please extract it from here and create another component for it -->
        <!-- NOTE: Following code is commented with the intention of removing Swogo bundle. -->
        <!-- We do not need Swogo bundles with marketplace release -->
        <!-- {#if window['ACC'].config.manualBundleEnabled && isStockAvailableForCurrentStore} -->
        <!--   <FrequentlyBoughtMain freqBoughtData={$pdpManualBundleData} on:manualBundleToCart={manualBundlePayload} /> -->
        <!-- {/if} -->
      </IntersectionObserver>
    {/if}
  </div>
  <!-- Bottom content -->
  <div class="bottom-content">
    {#if $miraklSponsoredProducts.length > 0}
      <ProductCarouselComponent
        products={$miraklSponsoredProducts[0]}
        displayBanners={$displayBanners}
        treat3pItemsAsSponsored={true}
      />
    {/if}
    <div class="bottom-content-group">
      {#if hasSpecialOffersSection}
        <PdpDivider />
      {/if}
      {#if isProductAvailability && hasBundlePromotions}
        <PdpBundlePromotion data={$pdpBundlePromotionData} on:bundleClicked={data => addBundleToCart(data.detail)} />
      {/if}
      <div class="bottom-content-special-offers">
        <BasketLevelPromotion basketPromotions={$productDetailMainData?.basketPromotions} />
        <ProductSpecialOffers />
      </div>
    </div>

    {#if isResponsive && isProductAvailability}
      {#if $productDetailMainData?.manualBundleProducts && $productDetailMainData?.manualBundleProducts.length > 0}
        <PdpDivider />
        <ManualBundle manualBundleData={$pdpManualBundleData} on:manualBundleToCart={manualBundlePayload} />
      {/if}

      <!-- WARN: If this component does more than that, please extract it from here and create another component for it -->
      <!-- NOTE: Following code is commented with the intention of removing Swogo bundle. -->
      <!-- We do not need Swogo bundles with marketplace release -->
      <!-- {#if window['ACC'].config.manualBundleEnabled && isStockAvailableForCurrentStore} -->
      <!--   <FrequentlyBoughtMain freqBoughtData={$pdpManualBundleData} on:manualBundleToCart={manualBundlePayload} /> -->
      <!-- {/if} -->
    {/if}
    {#if $productDetailMainData?.liveStreamAvailable}
      <ProductLiveVideo />
    {/if}
    <div id="item_page-rank1" class="yCmsComponent"></div>
    <div id="item_page-rank2" class="yCmsComponent"></div>
    <div id="item_page-rank3" class="yCmsComponent"></div>
    <!-- For recently viewed Items -->
    <div id="item_page-history" class="yCmsComponent pdp-category-page-history"></div>
  </div>
  <div id="zoomed-img-container"></div>
</div>
<section class="add-to-cart-dialog-wrapper">
  <AddToCartDialog content={$addToCartContent} open={$openAddToCartDrawer} />
</section>

<!-- This is replacing PdpStory component -->
<HighlightDetailsPopup data={$pdpHighlightPopupData} />

{#if $productDetailMainData?.isDigitalGiftCard != true && isResponsive}
  <ProductDetailsSpecs
    on:addToCart={() => onAddToCart()}
    on:openWriteReview={() => (writeReviewOpen = true)}
    data={$pdpSpecsAndStickyBarData}
  />
{/if}

{#if $productDetailMainData?.isAddToCartEnabled && ($productDetailMainData?.digitalDeliveryItem || (!$productDetailMainData?.isComingSoon && $productDetailMainData?.stock.stockLevelStatus.code != 'outOfStock'))}
  <div class="hide-on-desktop sticky_scroll_bar add_to_cart-conatiner">
    <AddToCartContainer
      data={$addToCartData}
      on:addToCart={() => onAddToCart()}
      on:changeWishList={data => handleWishlistChange(data)}
    />
    <ProductExtraLinks data={$pdpProductExtraLinksData} />
  </div>
{/if}

<WriteReview productDetails={$productDetails} bind:open={writeReviewOpen} />
<ProductShopMoreSection shopMoreDetails={$productDetailMainData?.shopMoreDetails} />
<!-- <Snackbar /> -->
<ExtraSnackBar />
{#if svelteModuleFooterEnabled && !isMobileUIExperience()}
  <AppFooterPage />
{/if}

<style lang="scss">
  @import '../../common/styles/colors.new.scss';
  .c_pdppricecontainer {
    margin-bottom: 18px;
    padding-left: 7px;
  }
  .c_jood-pdp-container {
    margin-bottom: 20px;
    &.mobile {
      padding: 0 16px;
    }
  }
  .test-container {
    margin: 2rem 1rem;
    // border: 1px solid red;
    display: flex;
    flex-direction: column;
    width: 45vw;
  }

  .pdp-container {
    margin: 0 auto;
    grid-template-columns: 1fr;
    grid-auto-rows: minmax(0, auto);
    max-width: 1440px;
    padding: 0px 0px 0px 0px;
    background-color: $primary-white;

    .title-container {
      padding-bottom: 16px;
      background-color: $neutral-light-04;
      :global(.tag-container) {
        display: flex;
        flex-direction: row;
        gap: 10px;
        padding: 8px 16px 0;
        @include desktop-min-width {
          background-color: transparent;
          padding: 0;
          margin-bottom: 10px;
        }
      }
    }

    .right-content {
      padding-top: 20px;

      @include responsive {
        padding: 8px;
      }

      .no-free-gift-container {
        padding: 0 16px;
        @include desktop-min-width {
          padding: 0;
        }
        div {
          font-size: 14px;
          color: #051f2f;
          display: flex;
          align-items: center;
          font-weight: 500;
          background: rgba(244, 202, 36, 0.1);
          border: 1px solid #f4ca24;
          border-radius: 8px;
          padding: 12px;
        }
      }
    }
    .bottom-content {
      .bottom-content-group {
        display: flex;
        flex-direction: column;
        padding: 24px 16px;
        gap: 50px;

        .bottom-content-special-offers {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
      }
    }

    @include desktop-min-width {
      display: grid;
      background-color: $primary-white;
      grid-template-columns: 57.083% 42.916%;
      /* left:  822px on 1440px resolution*/
      grid-template-areas:
        'LCnt RTitle'
        'LCnt RCnt'
        'BCnt BCnt';
      grid-template-rows: minmax(0, auto) 1fr auto;
      grid-auto-rows: minmax(0, auto);
      .left-content {
        grid-area: LCnt;
        // position: sticky;
        // top: 40px;
        .light-container {
          background-color: $neutral-light-04;
          border-radius: 12px;
          padding-bottom: 24px;
        }
        .light-container-giftCard {
          background-color: $neutral-light-04;
          padding-bottom: 24px;
        }
      }
      .right-content {
        grid-area: RCnt;
        padding: 20px 37px 16px 37px;
      }
      .bottom-content {
        grid-area: BCnt;
        .bottom-content-group {
          padding: 64px 48px;
        }
      }
      .title-container {
        grid-area: RTitle;
        background-color: $primary-white;
        padding: 0px 37px 0px 37px;
      }
    }
  }

  .hide-on-mobile {
    @media screen and (max-width: 599px) {
      display: none;
    }
  }

  :global {
    html.pdp-sticky-added {
      .c_global-header.minimal {
        z-index: 10;
        .c_nav-main-bar {
          box-shadow: none;
        }
      }
    }

    #category_page-history {
      .c_product-stock,
      .c_gift-block,
      .c_item--grid--price,
      .c_rating,
      .c_item--grid--tag,
      .c_item--grid--wishlist {
        display: none;
      }
      .c_item--grid--title p {
        position: absolute;
      }
      .c_item--grid {
        height: 100%;
        padding: 1.2rem 1.2rem 1.2rem 0;
        width: 17rem;
        @include desktop-min-width {
          padding: 1.6rem 1.6rem 1.6rem 0;
          width: 25.2rem;
        }
      }

      .c_item--grid--detail {
        margin: 1.6rem;
      }

      &.pdp-category-page-history {
        .rr_parent_item_container {
          .tile-content-wrapper {
            .product-tile-container {
              .product-image-section {
                @include desktop-min-width {
                  margin-bottom: 32px;
                }
              }
            }
          }
        }
      }
    }

    #category_page-history,
    #category_page-family_bottom_rank3,
    #category_page-family_bottom_rank2,
    #category_page-family_bottom_rank1 {
      width: 100%;
    }
  }

  .add_to_cart-conatiner {
    z-index: 3;
  }
  .sticky_scroll_bar {
    position: fixed;
    bottom: 0;
    width: 100%;
    :global(.product_extra_links) {
      background-color: $primary-white;
      margin-top: -8px !important;
      padding: 0px 16px 16px !important;
    }
  }

  .extra_btn_wrapper,
  :global(.extra-btn-action-wrapper) {
    margin-top: 24px;
    gap: 18px;
    :global(.mdc-typography--body2) {
      display: flex;
      gap: 4px;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      text-transform: capitalize;
      color: $icon-only-icon-blue;
    }
    @include desktop-min-width {
      gap: 36px;
    }
  }

  .sticky_header_bar {
    position: fixed;
    top: 0px;
    width: 100%;
    z-index: 14;
    filter: drop-shadow(0px 4px 12px rgba(219, 227, 232, 0.6));
  }

  .isComingSoonBg {
    background: $functional-green-03;
  }
  :global(.fav_icon) {
    display: flex;
    align-items: center;
  }
  :global(.price_alert_icon) {
    color: $tertiary-blue-02;
    font-size: 16px;
    @include desktop-min-width {
      font-size: 24px;
    }
  }
  :global(.wishlist_icon) {
    color: $tertiary-blue-02;
    font-size: 16px;
    @include desktop-min-width {
      font-size: 24px;
    }
  }

  :global {
    html:has(.mdc-dialog--open) {
      overflow: hidden !important;
    }
  }
</style>
